import type { SVGProps } from 'react';

const SvgSorting = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={20}
    viewBox='0 0 20 20'
    width={20}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g fill='currentColor'>
      <path
        d='M14.791 12.792 10 17.583l-4.792-4.791zM5.208 7.208 10 2.417l4.791 4.791z'
        fill='currentColor'
      />
    </g>
  </svg>
);
export default SvgSorting;
